<div class="row__actions">
    <button
        emmaButton
        (mouseenter)="onRowActionsMenu($event)"
        (mouseleave)="onRowActionsMenuLeave()"
        class="row__actions--button no-focus-btn"
        [ngClass]="{
            active: showMenu
        }"
        color="brand"
        [noBg]="true"
        [hasIcon]="true"
    >
        ···
    </button>
    <div
        *ngIf="showMenu"
        class="row__actions--menu-bridge"
        [ngStyle]="menuBridgeStyles"
        (mouseenter)="onRowActionsMenuEnter()"
        (mouseleave)="onRowActionsMenuLeave()"
    ></div>
    <div
        *ngIf="showMenu"
        #menuElement
        class="row__actions--menu"
        [ngStyle]="menuStyles"
        (mouseenter)="onRowActionsMenuEnter()"
        (mouseleave)="onRowActionsMenuLeave()"
    >
        <ul>
            <li *ngFor="let action of actions" [ngClass]="{ disabled: action.disabled }">
                <ng-container *ngIf="action.disabled" class="disabled">
                    <div [ngbPopover]="action.description || ''" container="body">
                        <i
                            *ngIf="action.icon"
                            [class]="'la la-' + (action.icon || '')"
                            aria-hidden="true"
                        ></i>
                        {{ action.title }}
                    </div>
                </ng-container>
                <ng-container *ngIf="!action.disabled">
                    <div (click)="action.$click && onRowActionClick($event, row, action)">
                        <i
                            *ngIf="action.icon"
                            [class]="'la la-' + (action.icon || '')"
                            aria-hidden="true"
                        ></i>
                        {{ action.title }}
                    </div>
                </ng-container>
            </li>
        </ul>
    </div>
</div>
